<template>
  <div class="contact-page">
    <!-- Editorial Hero -->
    <section class="ahrs-page-hero hero-photo-contact">
      <div class="ahrs-page-hero-wrap">
        <div class="ahrs-page-eyebrow" data-aos="fade-up">
          <span class="dot"></span>Contact &amp; Support
        </div>
        <h1 class="ahrs-page-title" data-aos="fade-up" data-aos-delay="100">
          Talk to
          <span class="ahrs-page-italic">the AHRS secretariat.</span>
        </h1>
        <p class="ahrs-page-lede" data-aos="fade-up" data-aos-delay="200">
          Reach our team for delegate enquiries, partnership conversations,
          accommodation, and everything in between.
        </p>
        <div class="ahrs-page-meta" data-aos="fade-up" data-aos-delay="300">
          <div class="m">
            <svg viewBox="0 0 24 24" stroke-linecap="round">
              <rect x="3" y="4.5" width="18" height="17" rx="2" />
              <path d="M3 9h18M8 2.5v4M16 2.5v4" />
            </svg>
            19&ndash;22 August 2026
          </div>
          <div class="m">
            <svg viewBox="0 0 24 24" stroke-linecap="round">
              <path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z" />
              <circle cx="12" cy="10" r="2.6" />
            </svg>
            Mount Meru Hotel, Arusha
          </div>
        </div>
        <div class="ahrs-page-stats" data-aos="fade-up" data-aos-delay="400">
          <div class="ahrs-page-stat">
            <span class="n">3</span>
            <span class="l">Contact Persons</span>
          </div>
          <div class="ahrs-page-stat">
            <span class="n">2</span>
            <span class="l">Languages</span>
          </div>
          <div class="ahrs-page-stat">
            <span class="n">21+</span>
            <span class="l">Partner Orgs</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Content -->
    <section class="contact-content">
      <div class="container-wide">

        <!-- Top Row: Event Info + Quick Contacts -->
        <div class="top-grid">

          <!-- Event Info Card -->
          <div class="info-card event-card" data-aos="fade-up" data-aos-delay="100">
            <div class="card-header">
              <div class="card-icon"><i class="fas fa-calendar-check"></i></div>
              <h2 class="card-title">Event</h2>
            </div>
            <div class="info-rows">
              <div class="info-row">
                <div class="info-icon"><i class="fas fa-map-marker-alt"></i></div>
                <div class="info-text">
                  <span class="info-label">Venue</span>
                  <span class="info-value">Mount Meru Hotel</span>
                </div>
              </div>
              <div class="info-row">
                <div class="info-icon"><i class="fas fa-calendar-alt"></i></div>
                <div class="info-text">
                  <span class="info-label">Date</span>
                  <span class="info-value">19–22 August 2026</span>
                </div>
              </div>
              <div class="info-row">
                <div class="info-icon"><i class="fas fa-envelope"></i></div>
                <div class="info-text">
                  <span class="info-label">Email</span>
                  <a href="mailto:register@africahrsummit.org" class="info-link">register@africahrsummit.org</a>
                </div>
              </div>
              <div class="info-row">
                <div class="info-icon"><i class="fas fa-globe"></i></div>
                <div class="info-text">
                  <span class="info-label">Website</span>
                  <a href="https://www.africahrsummit.org" target="_blank" class="info-link">www.africahrsummit.org</a>
                </div>
              </div>
              <div class="info-row">
                <!-- <div class="info-icon"><i class="fas fa-language"></i></div>
                <div class="info-text">
                  <span class="info-label">Languages</span>
                  <span class="info-value">English &amp; French (with interpretation)</span>
                </div> -->
              </div>
            </div>
          </div>

          <!-- About the Summit -->
          <div class="info-card about-card" data-aos="fade-up" data-aos-delay="200">
            <div class="card-header">
              <div class="card-icon"><i class="fas fa-info-circle"></i></div>
              <h2 class="card-title">About AHRS 2026</h2>
            </div>
            <p class="about-text">
              The Africa Human Resource Summit (AHRS) is the premier pan-African platform
              dedicated to shaping the future of work across the continent. The Summit convenes
              HR experts and professionals from across Africa to engage, learn, and collaborate
              on emerging trends and best practices.
            </p>
            <p class="about-text">
              AHRS offers the largest and most influential networking environment for HR
              professionals in Africa, enabling strategic connections, knowledge sharing,
              and impactful partnerships.
            </p>
            <div class="about-theme">
              <i class="fas fa-quote-left"></i>
              "Transforming Africa's Workforce for the Future"
            </div>
          </div>
        </div>

        <!-- Admin Support -->
        <div class="section-heading" data-aos="fade-up">
          <div class="section-icon"><i class="fas fa-headset"></i></div>
          <h2 class="section-title">Administrative Support</h2>
        </div>
        <div class="contacts-grid" data-aos="fade-up">
          <div class="contact-card">
            <div class="contact-avatar">
              <div class="avatar-initials">DD</div>
              <div class="avatar-ring"></div>
            </div>
            <h3 class="contact-name">Denis Derua</h3>
            <p class="contact-role">Administrative Support</p>
            <div class="contact-links">
              <a href="mailto:denis.derua@africahrsummit.org" class="contact-link email">
                <i class="fas fa-envelope"></i> denis.derua@africahrsummit.org
              </a>
              <a href="tel:+255716507642" class="contact-link phone">
                <i class="fas fa-phone"></i> +255 716 507 642
              </a>
            </div>
          </div>

          <div class="contact-card">
            <div class="contact-avatar">
              <div class="avatar-initials">GN</div>
              <div class="avatar-ring"></div>
            </div>
            <h3 class="contact-name">Grace Nzula</h3>
            <p class="contact-role">Administrative Support</p>
            <div class="contact-links">
              <a href="mailto:grace.nzula@africahrsummit.org" class="contact-link email">
                <i class="fas fa-envelope"></i> grace.nzula@africahrsummit.org
              </a>
              <a href="tel:+254721442223" class="contact-link phone">
                <i class="fas fa-phone"></i> +254 721 442 223
              </a>
            </div>
          </div>

          <!-- <div class="contact-card partnership-card">
            <div class="contact-avatar">
              <div class="avatar-initials">BD</div>
              <div class="avatar-ring"></div>
            </div>
            <h3 class="contact-name">Bruno Daniel</h3>
            <p class="contact-role">Partnership Director</p>
            <div class="contact-links">
              <a href="mailto:brunodaniel@thrapa.or.tz" class="contact-link email">
                <i class="fas fa-envelope"></i> brunodaniel@thrapa.or.tz
              </a>
              <a href="tel:+255755555495" class="contact-link phone">
                <i class="fas fa-phone"></i> +255 755 555 495
              </a>
            </div>
            <span class="partnership-badge">Partnerships</span>
          </div> -->
        </div>

        <!-- Location Map Placeholder -->
        <div class="location-card" data-aos="fade-up">
          <div class="location-left">
            <div class="card-header">
              <div class="card-icon"><i class="fas fa-map-marked-alt"></i></div>
              <h2 class="card-title">Venue Location</h2>
            </div>
            <div class="location-details">
              <div class="location-detail">
                <i class="fas fa-hotel"></i>
                <div>
                  <strong>Mount Meru Hotel</strong>
                  <span>Arusha, Tanzania</span>
                </div>
              </div>
              <div class="location-detail">
                <i class="fas fa-plane"></i>
                <div>
                  <strong>Nearest International Airport</strong>
                  <span>Kilimanjaro International Airport (JRO)</span>
                </div>
              </div>
              <div class="location-detail">
                <i class="fas fa-mountain"></i>
                <div>
                  <strong>Surroundings</strong>
                  <span>Gateway to Kilimanjaro &amp; Ngorongoro Conservation Area</span>
                </div>
              </div>
            </div>
            <router-link to="/accommodation" class="location-btn">
              <i class="fas fa-bed"></i> View Accommodation Options
            </router-link>
          </div>
          <div class="location-map">
            <div class="map-placeholder">
              <div class="map-pin"><i class="fas fa-map-marker-alt"></i></div>
              <div class="map-label">Mount Meru Hotel<br/><small>Arusha, Tanzania</small></div>
              <div class="map-rings">
                <div class="ring r1"></div>
                <div class="ring r2"></div>
                <div class="ring r3"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- CTA -->
        <div class="contact-cta" data-aos="zoom-in">
          <div class="cta-glow"></div>
          <h2 class="cta-title">Ready to join AHRS 2026?</h2>
          <p class="cta-subtitle">Secure your place today and be part of Africa's most influential HR gathering.</p>
          <div class="cta-buttons">
            <router-link to="/registration" class="cta-btn primary">
              <i class="fas fa-ticket-alt"></i> Register Now
            </router-link>
            <router-link to="/sponsorship" class="cta-btn secondary">
              <i class="fas fa-handshake"></i> Become a Partner
            </router-link>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ContactView",
  mounted() {
    this.initParticles();
  },
  beforeUnmount() {
    if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
    if (this._resizeHandler) window.removeEventListener("resize", this._resizeHandler);
  },
  methods: {
    onHeroMouseMove(e) {
      const glow = this.$refs.cursorGlow;
      if (!glow) return;
      const rect = this.$refs.heroSection.getBoundingClientRect();
      glow.style.left = e.clientX - rect.left + "px";
      glow.style.top = e.clientY - rect.top + "px";
    },
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      const resize = () => {
        const page = document.querySelector(".contact-page");
        canvas.width = window.innerWidth;
        canvas.height = page ? page.offsetHeight : window.innerHeight;
      };
      resize();
      this._resizeHandler = resize;
      window.addEventListener("resize", resize);
      const colors = ["#4ade80", "#22c55e", "#f59e0b", "#10b981", "#86efac"];
      const particles = Array.from({ length: 60 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 2.5 + 0.5,
        color: colors[Math.floor(Math.random() * colors.length)],
        vx: (Math.random() - 0.5) * 0.4,
        vy: (Math.random() - 0.5) * 0.4,
        alpha: Math.random() * 0.6 + 0.2,
      }));
      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach((p) => {
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle = p.color + Math.floor(p.alpha * 255).toString(16).padStart(2, "0");
          ctx.fill();
          p.x += p.vx;
          p.y += p.vy;
          if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
          if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
        });
        this.animationFrame = requestAnimationFrame(draw);
      };
      draw();
    },
  },
};
</script>

<style scoped>
/* ── Page ───────────────────────────────────────────── */
.contact-page {
  min-height: 100vh;
  background: #f8faf9;
  position: relative;
  overflow: hidden;
}

/* Editorial hero backdrop photo */
.hero-photo-contact {
  --hero-photo: url("~@/assets/images/past Ahrs/member.jpg");
}

/* ── Animated Background ────────────────────────────── */
.animated-bg { position: absolute; inset: 0; z-index: 0; pointer-events: none; }
.particle-canvas { position: absolute; inset: 0; opacity: 0.7; }
.bg-grid {
  position: absolute; inset: 0;
  background-image:
    linear-gradient(rgba(74, 222, 128, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(74, 222, 128, 0.1) 1px, transparent 1px);
  background-size: 60px 60px;
}
.gradient-orb { position: absolute; border-radius: 50%; filter: blur(80px); opacity: 0.3; }
.orb-1 { width: 600px; height: 600px; background: radial-gradient(circle, #1a472a, transparent); top: -150px; left: -150px; animation: orbFloat 12s ease-in-out infinite; }
.orb-2 { width: 500px; height: 500px; background: radial-gradient(circle, #4ade80, transparent); bottom: 20%; right: -100px; animation: orbFloat 15s ease-in-out infinite reverse; }
.orb-3 { width: 400px; height: 400px; background: radial-gradient(circle, #bbf7d0, transparent); top: 40%; left: 40%; animation: orbFloat 18s ease-in-out infinite; }
.light-stream { position: absolute; width: 1px; background: linear-gradient(to bottom, transparent, rgba(26,71,42,0.12), transparent); animation: streamFlow 6s ease-in-out infinite; }
.stream-1 { height: 40%; top: 5%; left: 20%; }
.stream-2 { height: 30%; top: 30%; left: 75%; animation-delay: 3s; }
.geo-shape { position: absolute; opacity: 0.22; animation: geoSpin 20s linear infinite; }
.hex { width: 300px; height: 300px; border: 2px solid #4ade80; clip-path: polygon(50% 0%,100% 25%,100% 75%,50% 100%,0% 75%,0% 25%); top: 10%; right: 5%; }
.triangle { width: 200px; height: 200px; border: 2px solid #f59e0b; clip-path: polygon(50% 0%,100% 100%,0% 100%); bottom: 15%; left: 5%; animation-direction: reverse; }
.circle-ring { width: 250px; height: 250px; border: 2px solid #86efac; border-radius: 50%; top: 55%; right: 15%; animation-duration: 30s; }
@keyframes orbFloat { 0%,100%{transform:translate(0,0)} 50%{transform:translate(30px,20px)} }
@keyframes streamFlow { 0%,100%{opacity:0;transform:scaleY(.5)} 50%{opacity:1;transform:scaleY(1)} }
@keyframes geoSpin { from{transform:rotate(0)} to{transform:rotate(360deg)} }

/* ── Container ──────────────────────────────────────── */
.container-wide { max-width: 1280px; margin: 0 auto; padding: 0 24px; position: relative; z-index: 2; }

/* ── Hero ───────────────────────────────────────────── */
.contact-hero {
  position: relative; padding: 140px 0 110px; text-align: center;
  z-index: 2; background: linear-gradient(135deg, #0f2419 0%, #1a472a 60%, #2d5f3f 100%);
  overflow: hidden;
}
.hero-cursor-glow {
  position: absolute; width: 320px; height: 320px; border-radius: 50%;
  background: radial-gradient(circle, rgba(74,222,128,0.15), transparent 70%);
  transform: translate(-50%,-50%); pointer-events: none;
  transition: left 0.08s ease, top 0.08s ease; z-index: 0;
}
.hero-pill {
  position: absolute; background: rgba(74,222,128,0.1); border: 1px solid rgba(74,222,128,0.25);
  color: rgba(255,255,255,0.7); font-size: 0.78rem; font-weight: 600;
  padding: 6px 14px; border-radius: 50px; display: flex; align-items: center;
  gap: 6px; backdrop-filter: blur(6px); pointer-events: none; z-index: 1;
}
.hero-pill i { color: #4ade80; }
.pill-1 { top: 22%; left: 7%; animation: pillFloat 6s ease-in-out infinite; }
.pill-2 { top: 35%; right: 8%; animation: pillFloat 8s ease-in-out infinite reverse; }
.pill-3 { bottom: 28%; left: 5%; animation: pillFloat 7s ease-in-out infinite 1s; }
@keyframes pillFloat { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-12px)} }

.hero-badge {
  display: inline-flex; align-items: center; gap: 10px;
  background: rgba(74,222,128,0.12); border: 1px solid rgba(74,222,128,0.35);
  color: #4ade80; padding: 8px 20px; border-radius: 50px;
  font-size: 0.85rem; font-weight: 600; letter-spacing: 1px;
  text-transform: uppercase; margin-bottom: 24px; backdrop-filter: blur(8px);
}
.badge-icon { font-size: 1rem; }
.hero-title {
  font-size: clamp(2.4rem, 5vw, 4rem); font-weight: 800;
  color: #ffffff; line-height: 1.1; margin-bottom: 20px;
}
.title-highlight {
  background: linear-gradient(90deg, #4ade80, #f59e0b, #4ade80);
  background-size: 200%; -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; background-clip: text;
  animation: shimmer 4s linear infinite;
}
@keyframes shimmer { 0%{background-position:0% center} 100%{background-position:200% center} }
.hero-subtitle {
  font-size: 1.1rem; color: rgba(255,255,255,0.65);
  max-width: 620px; margin: 0 auto 28px; line-height: 1.7;
}
.hero-meta { display: flex; justify-content: center; align-items: center; gap: 14px; flex-wrap: wrap; }
.meta-item { color: rgba(255,255,255,0.5); font-size: 0.9rem; display: flex; align-items: center; gap: 6px; }
.meta-item i { color: #4ade80; }
.meta-divider { color: rgba(255,255,255,0.2); }
.hero-stats {
  display: inline-flex; align-items: center; margin-top: 40px;
  background: rgba(255,255,255,0.07); border: 1px solid rgba(74,222,128,0.2);
  border-radius: 60px; padding: 16px 36px; backdrop-filter: blur(12px);
  flex-wrap: wrap; justify-content: center;
}
.stat-item { display: flex; flex-direction: column; align-items: center; padding: 0 24px; }
.stat-num { font-size: 1.8rem; font-weight: 800; color: #4ade80; line-height: 1; }
.stat-label { font-size: 0.75rem; color: rgba(255,255,255,0.5); text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; }
.stat-divider { width: 1px; height: 36px; background: rgba(74,222,128,0.2); flex-shrink: 0; }
.hero-wave { position: absolute; bottom: -1px; left: 0; right: 0; line-height: 0; }
.hero-wave svg { display: block; width: 100%; height: 90px; }

/* ── Content ────────────────────────────────────────── */
.contact-content { position: relative; z-index: 2; padding: 80px 0 100px; }

/* ── Top Grid ───────────────────────────────────────── */
.top-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 60px; }

/* ── Info Cards ─────────────────────────────────────── */
.info-card {
  background: #ffffff; border: 1px solid rgba(26,71,42,0.12);
  border-radius: 20px; padding: 36px; box-shadow: 0 4px 24px rgba(0,0,0,0.08);
}
.card-header { display: flex; align-items: center; gap: 14px; margin-bottom: 28px; }
.card-icon {
  width: 46px; height: 46px;
  background: linear-gradient(135deg, #1a472a, #2d5f3f);
  border-radius: 12px; display: flex; align-items: center;
  justify-content: center; color: #4ade80; font-size: 1.1rem; flex-shrink: 0;
}
.card-title { font-size: 1.3rem; font-weight: 700; color: #0f2419; }

.info-rows { display: flex; flex-direction: column; gap: 16px; }
.info-row { display: flex; align-items: flex-start; gap: 14px; }
.info-icon {
  width: 36px; height: 36px; background: rgba(26,71,42,0.06);
  border-radius: 10px; display: flex; align-items: center;
  justify-content: center; color: #1a472a; font-size: 0.9rem; flex-shrink: 0;
}
.info-text { display: flex; flex-direction: column; gap: 2px; }
.info-label { font-size: 0.75rem; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.5px; }
.info-value { font-size: 0.95rem; color: #1f2937; font-weight: 500; }
.info-link { font-size: 0.95rem; color: #1a472a; font-weight: 600; text-decoration: none; transition: color 0.2s; }
.info-link:hover { color: #4ade80; }

.about-text { font-size: 0.95rem; color: #4b5563; line-height: 1.7; margin-bottom: 14px; }
.about-theme {
  background: rgba(26,71,42,0.06); border-left: 3px solid #4ade80;
  border-radius: 0 10px 10px 0; padding: 14px 18px;
  font-size: 0.9rem; font-weight: 600; color: #1a472a; font-style: italic;
  margin-top: 4px;
}
.about-theme i { margin-right: 8px; color: #4ade80; }

/* ── Section Heading ────────────────────────────────── */
.section-heading {
  display: flex; align-items: center; gap: 14px;
  margin-bottom: 28px;
}
.section-icon {
  width: 46px; height: 46px;
  background: linear-gradient(135deg, #1a472a, #2d5f3f);
  border-radius: 12px; display: flex; align-items: center;
  justify-content: center; color: #4ade80; font-size: 1.1rem;
}
.section-title { font-size: 1.5rem; font-weight: 700; color: #0f2419; }

/* ── Contacts Grid ──────────────────────────────────── */
.contacts-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-bottom: 60px; }

.contact-card {
  background: #ffffff; border: 1px solid rgba(26,71,42,0.12);
  border-radius: 20px; padding: 32px 24px; text-align: center;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07); position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.contact-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(26,71,42,0.12), 0 0 0 1px rgba(74,222,128,0.3);
}
.partnership-card { border-color: rgba(26,71,42,0.2); background: #f0fdf4; }

.contact-avatar { position: relative; width: 80px; height: 80px; margin: 0 auto 18px; }
.avatar-initials {
  width: 80px; height: 80px; border-radius: 50%;
  background: linear-gradient(135deg, #1a472a, #4ade80);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.4rem; font-weight: 700; color: #fff; position: relative; z-index: 1;
}
.avatar-ring {
  position: absolute; inset: -4px; border-radius: 50%;
  border: 2px solid transparent;
  background: linear-gradient(135deg, #4ade80, #f59e0b) border-box;
  -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: destination-out; mask-composite: exclude;
  animation: ringPulse 2.5s ease-in-out infinite;
}
@keyframes ringPulse { 0%,100%{opacity:.6;transform:scale(1)} 50%{opacity:1;transform:scale(1.05)} }

.contact-name { font-size: 1.15rem; font-weight: 700; color: #0f2419; margin-bottom: 4px; }
.contact-role { font-size: 0.82rem; color: #6b7280; font-weight: 500; margin-bottom: 18px; text-transform: uppercase; letter-spacing: 0.5px; }

.contact-links { display: flex; flex-direction: column; gap: 10px; }
.contact-link {
  display: flex; align-items: center; gap: 8px;
  font-size: 0.83rem; font-weight: 600; text-decoration: none;
  padding: 8px 14px; border-radius: 10px; transition: all 0.25s ease;
}
.contact-link i { font-size: 0.8rem; flex-shrink: 0; }
.contact-link.email { background: rgba(26,71,42,0.06); color: #1a472a; border: 1px solid rgba(26,71,42,0.1); }
.contact-link.email:hover { background: rgba(26,71,42,0.12); }
.contact-link.phone { background: rgba(74,222,128,0.1); color: #15803d; border: 1px solid rgba(74,222,128,0.2); }
.contact-link.phone:hover { background: rgba(74,222,128,0.18); }

.partnership-badge {
  position: absolute; top: 14px; right: 14px;
  background: linear-gradient(135deg, #1a472a, #4ade80);
  color: #fff; font-size: 0.68rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.6px;
  padding: 3px 10px; border-radius: 50px;
}

/* ── Location Card ──────────────────────────────────── */
.location-card {
  display: grid; grid-template-columns: 1fr 1fr; gap: 0;
  background: #ffffff; border: 1px solid rgba(26,71,42,0.12);
  border-radius: 20px; overflow: hidden;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08); margin-bottom: 60px;
}
.location-left { padding: 36px; }
.location-details { display: flex; flex-direction: column; gap: 20px; margin: 24px 0; }
.location-detail { display: flex; align-items: flex-start; gap: 14px; }
.location-detail i { color: #4ade80; font-size: 1.1rem; margin-top: 3px; flex-shrink: 0; }
.location-detail strong { display: block; font-size: 0.9rem; color: #0f2419; font-weight: 700; }
.location-detail span { font-size: 0.85rem; color: #6b7280; }
.location-btn {
  display: inline-flex; align-items: center; gap: 8px;
  background: linear-gradient(135deg, #1a472a, #2d5f3f);
  color: #ffffff; font-weight: 700; font-size: 0.9rem;
  padding: 12px 24px; border-radius: 50px; text-decoration: none;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: 0 6px 20px rgba(26,71,42,0.25);
}
.location-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(26,71,42,0.35); color: #fff; }

.location-map {
  background: linear-gradient(135deg, #0f2419, #1a472a);
  display: flex; align-items: center; justify-content: center;
  min-height: 280px; position: relative; overflow: hidden;
}
.map-placeholder { text-align: center; position: relative; z-index: 2; }
.map-pin {
  font-size: 3rem; color: #4ade80; margin-bottom: 12px;
  animation: pinBounce 2s ease-in-out infinite;
}
@keyframes pinBounce { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
.map-label { color: #ffffff; font-weight: 700; font-size: 1rem; line-height: 1.5; }
.map-label small { color: rgba(255,255,255,0.6); font-size: 0.8rem; font-weight: 400; }
.map-rings { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); }
.ring {
  position: absolute; border-radius: 50%; border: 1px solid rgba(74,222,128,0.2);
  top: 50%; left: 50%; transform: translate(-50%,-50%);
  animation: ringExpand 3s ease-out infinite;
}
.r1 { width: 100px; height: 100px; animation-delay: 0s; }
.r2 { width: 180px; height: 180px; animation-delay: 1s; }
.r3 { width: 260px; height: 260px; animation-delay: 2s; }
@keyframes ringExpand { 0%{opacity:.5;transform:translate(-50%,-50%) scale(.8)} 100%{opacity:0;transform:translate(-50%,-50%) scale(1.4)} }

/* ── CTA ────────────────────────────────────────────── */
.contact-cta {
  text-align: center; padding: 60px 40px;
  background: linear-gradient(135deg, #0f2419 0%, #1a472a 60%, #2d5f3f 100%);
  border: 1px solid rgba(74,222,128,0.25);
  border-radius: 24px; position: relative; overflow: hidden;
  box-shadow: 0 20px 60px rgba(15,36,25,0.35);
}
.cta-glow { position: absolute; inset: 0; background: radial-gradient(ellipse at center, rgba(74,222,128,0.14), transparent 70%); pointer-events: none; }
.cta-title { font-size: 2rem; font-weight: 800; color: #ffffff; margin-bottom: 12px; }
.cta-subtitle { font-size: 1rem; color: rgba(255,255,255,0.82); max-width: 500px; margin: 0 auto 30px; }
.cta-buttons { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; }
.cta-btn {
  display: inline-flex; align-items: center; gap: 10px;
  font-weight: 700; font-size: 1rem; padding: 14px 32px;
  border-radius: 50px; text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.cta-btn.primary {
  background: linear-gradient(135deg, #1a472a, #4ade80); color: #ffffff;
  box-shadow: 0 8px 30px rgba(74,222,128,0.3);
}
.cta-btn.primary:hover { transform: translateY(-3px); box-shadow: 0 14px 40px rgba(74,222,128,0.5); color: #fff; }
.cta-btn.secondary {
  background: rgba(255,255,255,0.1); color: #ffffff;
  border: 1px solid rgba(255,255,255,0.25); backdrop-filter: blur(8px);
}
.cta-btn.secondary:hover { background: rgba(255,255,255,0.18); transform: translateY(-3px); color: #fff; }

/* ── Responsive ─────────────────────────────────────── */
@media (max-width: 1024px) {
  .contacts-grid { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 768px) {
  .contact-hero { padding: 120px 0 100px; }
  .hero-pill { display: none; }
  .hero-title { font-size: 2.2rem; }
  .hero-stats { padding: 12px 20px; }
  .stat-item { padding: 0 14px; }
  .stat-num { font-size: 1.4rem; }
  .top-grid { grid-template-columns: 1fr; }
  .contacts-grid { grid-template-columns: 1fr; }
  .location-card { grid-template-columns: 1fr; }
  .location-map { min-height: 200px; }
  .contact-cta { padding: 40px 24px; }
  .cta-title { font-size: 1.5rem; }
  .cta-buttons { flex-direction: column; align-items: center; }
}
</style>
